var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("path",{"fillRule":"evenodd","d":"M30 15a15 15 0 10-17.34 14.82V19.34H8.85V15h3.8v-3.3c0-3.76 2.25-5.84 5.67-5.84 1.64 0 3.36.3 3.36.3v3.68h-1.9c-1.86 0-2.44 1.16-2.44 2.35V15h4.16l-.66 4.34h-3.5v10.48A15 15 0 0030 15","key":1})]);
}

Facebook.defaultProps = {"fill":"#1877F2","viewBox":"0 0 30 30"};

module.exports = Facebook;

Facebook.default = Facebook;
